export default{
    install(Vue,options)
    {
      // 
      // http://www.hndzyz.com:6050
      Vue.prototype.Url = 'http://192.168.28.185:8088'
      // Vue.prototype.Url = 'http://192.168.28.216:8083'
      
    }
  }


// WEBPACK FOOTER //
// ./src/utils/commonUrl.js